import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation SpaceRecordAssignOrganization(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
    $input: OrganizationAssignmentInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceRecordAssignOrganization(
                  spaceRecordId: $spaceRecordId
                  input: $input
                )
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.SpaceRecordAssignOrganizationMutation,
  undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'app',
      graphql.transformers.OUT.select(
        'scenario',
        graphql.transformers.OUT.select(
          'extra',
          graphql.transformers.OUT.select(
            'space',
            graphql.transformers.OUT.select(
              'spaceRecordAssignOrganization',
              graphql.transformers.OUT.always(undefined),
            ),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceRecordAssignOrganizationMutation,
  undefined,
  graphql.schema.SpaceRecordAssignOrganizationMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
